import {Tag} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {MediaItemType} from '../../../../../../service/phototool/phototool-type';
import {useAiQualityEnabled} from '../../../../../../service/phototool/use-ai-quality-enabled';
import {qualityStatusDisplayMap} from '../../../photo-tool-const';

import * as styles from './photo-item.scss';

export function QualityBadge({photo}: {photo: MediaItemType}): JSX.Element | null {
    const isAiQualityEnabled = useAiQualityEnabled();
    const qualityBadge = photo.qualityStatus ? qualityStatusDisplayMap[photo.qualityStatus] : null;

    if (!isAiQualityEnabled || !qualityBadge) {
        return null;
    }

    return (
        <div className={styles.PhotoItem_quality}>
            <Tag color={qualityBadge.color}>
                <Locale stringKey={qualityBadge.localeKey} />
            </Tag>
        </div>
    );
}
